import React, {Component} from "react";
import {CardBody, List, StandardListCell} from "gd-react";
import GridDuck from "gridduck";
import GdModal from "../../components/GdModal/GdModal";
import NoItems from "../../components/noItems";
import "./dataFileImport.scss";

// Colour each run status so success/failure is scannable at a glance.
const STATUS_COLORS = {
    success: "#2e7d32",
    failed: "#d0021b",
    partial: "#e08600",
    skipped: "#9b9b9b",
    processing: "#2196f3"
};

// Timestamps come back as epoch/ISO; parse defensively (mirrors DataFileImportList's created_at).
function formatDate(value) {
    if (!value) return "";
    let d = new Date(value);
    return isNaN(d.getTime()) ? "" : d.toLocaleString();
}

// Modal listing the import execution logs for a single data file import config, newest run first.
class DataFileImportLogModal extends Component {
    constructor(props) {
        super(props);
        this.getList = this.getList.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    // The List merges this with its own paging; the config-id filter is supplied via the `filters` prop.
    getList(params) {
        return GridDuck.getDataFileImportLogs(params);
    }

    closeModal() {
        this.props.onClose();
    }

    render() {
        let item = this.props.item;
        let columns = [
            {
                component: StandardListCell,
                title: "Status",
                field: "status",
                custom: (log) => (
                    <span style={{color: STATUS_COLORS[log.status] || "#4a4a4a", fontWeight: 500, textTransform: "capitalize"}}>
                        {log.status || "—"}
                    </span>
                ),
                maxWidth: "110px"
            },
            {component: StandardListCell, title: "Started", field: "started_at", custom: (log) => formatDate(log.started_at), maxWidth: "180px"},
            {
                component: StandardListCell,
                title: "Rows",
                field: "rows_total",
                custom: (log) => (log.rows_processed != null || log.rows_total != null ? (log.rows_processed != null ? log.rows_processed : 0) + " / " + (log.rows_total != null ? log.rows_total : 0) : ""),
                maxWidth: "100px"
            },
            {component: StandardListCell, title: "Saved", field: "data_points_saved", maxWidth: "90px"},
            {component: StandardListCell, title: "Skipped", field: "rows_skipped", maxWidth: "90px"},
            {
                component: StandardListCell,
                title: "Errors",
                field: "error_message",
                custom: (log) => (log.error_count ? (log.error_count + (log.error_message ? " — " + log.error_message : "")) : ""),
                maxWidth: "none"
            }
        ];
        return (
            <GdModal
                title={item ? "Import Logs — " + item.name : "Import Logs"}
                open={this.props.open}
                wide
                onClose={this.closeModal}>
                <CardBody>
                    <div className={"data-file-import import-log-list"}>
                        <List
                            columns={columns}
                            getlist={this.getList}
                            filters={[{field: "data_file_import_id", value: item.id}]}
                            noitemelem={<NoItems text={"No import runs have been logged for this configuration yet"}/>}/>
                    </div>
                </CardBody>
            </GdModal>
        );
    }
}

export default DataFileImportLogModal;
